import React from 'react';

import PropTypes from 'prop-types';
import { Modal as UDSModal } from '@telus-uds/components-web';
import { useHistory } from 'react-router-dom';

import { getLocale } from '../../../misc';
import { ModalWidthOverride } from '../../../design/shared/modalOverrides';

export default function Modal({ children }) {
  const history = useHistory();
  const locale = getLocale();

  const handleClose = () => {
    history.push(`/${locale}/users`);
  };

  return (
    <>
      <ModalWidthOverride width="1000px" />
      <UDSModal
        isOpen={true}
        onClose={handleClose}
        variant={{ width: 'xl' }}
      >
        {/* QA-1: padding-right can't move a native scrollbar - it hugs the
            element's own border edge regardless of padding. Use marginRight
            to actually shrink the box so its scrollbar clears the close (X)
            button instead. */}
        <div style={{ maxHeight: "75vh", overflowY: "auto", marginRight: "1.5rem" }}>
          {children}
        </div>
      </UDSModal>
    </>
  );
}

Modal.propTypes = {
  children: PropTypes.node.isRequired
};
